import { keepPreviousData, useQuery } from "@tanstack/react-query";

import {
  ProductSelectionParams,
  suggestProductFilters,
} from "../../services/productPlaneApi";
import { queryKeys } from "./keys";

// Shortest text, trimmed, that is asked for suggestions
export const SUGGEST_MIN_LENGTH = 2;

const NO_SELECTION: ProductSelectionParams = {};

/**
 * TanStack Query hook for the suggestions of Explore's search field.
 *
 * The caller debounces the text. The suggestions are counted under
 * `selection`, the products Explore shows, so a count says what picking the
 * suggestion gives. Asks nothing for a text shorter than
 * `SUGGEST_MIN_LENGTH`; keeps the previous suggestions while the next load,
 * so that the list does not flicker while typing.
 */
export function useProductSuggestions(
  text: string,
  selection: ProductSelectionParams = NO_SELECTION,
  enabled = true,
) {
  const trimmed = text.trim();
  const params = { ...selection, text: trimmed };
  return useQuery({
    queryKey: queryKeys.productPlane.suggest(params),
    queryFn: () => suggestProductFilters(params),
    enabled: enabled && trimmed.length >= SUGGEST_MIN_LENGTH,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
